export type ColumnDefinition = {
  definition: string
  label: string
}

// ラベル・定義に紛れ込んだ改行やタブを 1 個の半角スペースに畳む。
// 直前の表は TSV なので、タブを残すと定義行が表の続きに見えてしまう。
const toSingleLine = (text: string): string => text.replace(/\s+/g, ' ').trim()

/**
 * 直列化済みのテーブルテキストに「列の定義」ブロックを追記します。
 *
 * 表本体は一切書き換えず、空行を1つ挟んで見出し + `ラベル: 定義` の行を並べます。
 * ラベルか定義が空の項目は落とし、残りが無ければ入力をそのまま返します
 * （見出しだけのブロックを出さないため）。
 *
 * @param serialized - 直列化済みのテーブルテキスト。
 * @param heading - ブロックの見出し（`# ` は本関数が付与する）。
 * @param definitions - 列のラベルと定義の組。
 * @returns 「列の定義」ブロックを追記したテキスト。
 */
export const appendColumnDefinitionsBlock = (
  serialized: string,
  heading: string,
  definitions: ColumnDefinition[],
): string => {
  const lines = definitions
    .map(({ definition, label }) => ({
      definition: toSingleLine(definition),
      label: toSingleLine(label),
    }))
    .filter(({ definition, label }) => definition !== '' && label !== '')
    .map(({ definition, label }) => `${label}: ${definition}`)

  if (lines.length === 0) {
    return serialized
  }

  const block = [`# ${toSingleLine(heading)}`, ...lines].join('\n')

  return [serialized, block].filter((part) => part !== '').join('\n\n')
}
